import { ControllerPage } from '../_app/cuchillo/pages/ControllerPage';
import Default from './Default';
import { Scroll } from '../_app/cuchillo/scroll/Scroll';
import gsap from 'gsap';

export default class NoScroll extends Default {
  constructor() {
    super();
  }

  afterShow() {
    if (this._header) gsap.to(this._header, { opacity: 1, duration: .2, delay: this.isFirstTime ? .5 : 0 });
    this._isActive = true;
    Scroll.show();
    document.body.classList.add('__noScroll');
  }

  afterHide() {
    super.afterHide();
    document.body.classList.remove('__noScroll');
  }
}

ControllerPage._addPage('no-scroll', NoScroll);
